import {Platform} from '@angular/cdk/platform';
import {Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Title} from '@angular/platform-browser';
import {NavigationEnd, Router} from '@angular/router';
import {environment} from '../environments/environment';
import {AuthService} from './auth/auth.service';
import {SegmentService} from './segment/segment.service';
import {AppStore} from './store/store';
import {UserModel} from './user/user.model';
import {userIsAdminSelector, userSelector} from './user/user.reducer';
import {UserService} from './user/user.service';
import {AuthorizationUtils} from './utils/authorization.utils';
import {SubSink} from 'subsink';

@Component({
  selector: 'app-root',
  template: `
    <div class="app-container">

      <app-progress></app-progress>

      <mat-toolbar color="primary">
        <a mat-button matTooltip="Home"
           [class]="{'active':activeRoute==='/home'}" routerLink="/home">Home</a>
        <a mat-button matTooltip="Search, create and share segments"
           [class]="{'active':activeRoute==='/segments'}"
           routerLink="/segments">Segments</a>
        <a mat-button matTooltip="Manage taxonomy segments structure"
           [class]="{'active':activeRoute==='/taxonomy'}"
           routerLink="/taxonomy">Taxonomy</a>
        <a mat-button matTooltip="Schedule platform synchronization manually"
           [class]="{'active':activeRoute==='/sync'}"
           routerLink="/sync">Synchronization</a>
        <a mat-button matTooltip="View Multishare history"
           [class]="{'active':activeRoute==='/multisharehistory'}"
           routerLink="/multisharehistory">Multishare History</a>
        <a mat-button matTooltip="Manage segment distribution accounts "
           [class]="{'active':activeRoute==='/distribution'}"
           routerLink="/distribution">Accounts</a>
        <a mat-button matTooltip="Manage the-trade-desk data"
           [class]="{'active':activeRoute==='/ttd'}"
           routerLink="/ttd/category">TTD</a>
        <a *ngIf="isAdmin" mat-button matTooltip="Search trough audit logs of segments and ttd categories"
           [class]="{'active':activeRoute==='/audit-logs'}" routerLink="/audit-logs">Audit Logs</a>
        <a [href]="sourceConfigUrl" mat-button matTooltip="Manage sources and client side deliveries" target="_blank">Source
          Configs (ADP)</a>

        <app-sw-update></app-sw-update>

        <span class="flex-spacer"></span>

        <span *ngIf="env !== 'production'" id="env-banner"
              style="color: yellowgreen; margin-left: 12px; margin-right:12px; font-size: larger;">
      <code>[env={{env}}]</code>
    </span>
        <span *ngIf="isUserSignedIn" id="toolbar-partner-select">
      <app-partner-select
        *ngIf="isAdmin"
        id="partner-select"></app-partner-select>
    </span>
      </mat-toolbar>

      <div class="app-content">
        <router-outlet></router-outlet>
      </div>

      <router-outlet name='aside'></router-outlet>

      <app-notification-bar></app-notification-bar>

    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    'app.component.scss'
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('left') left!: MatSidenav;

  version: string = environment.version;
  env: string = environment.env;
  isUserSignedIn = false;
  isAdmin!: boolean;
  user!: UserModel;
  unsubscribe = new SubSink();
  sourceConfigUrl: string = environment.sourceConfigFrontend;
  activeRoute = '/home';

  constructor(private appStore: AppStore,
              private userService: UserService,
              private router: Router,
              private segmentsActions: SegmentService,
              private authService: AuthService,
              private title: Title,
              private platform: Platform,
              private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    let snackBarRef;
    this.title.setTitle(environment.title);
    this.unsubscribe.sink = this.appStore.subscribe((state: AppStore) => {
      this.user = userSelector(state);
      this.isAdmin = userIsAdminSelector(state);
      this.isUserSignedIn = this.authService.isUserSignedIn();
    });

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.activeRoute = '/' + val.url.split('/').slice(1, 2).join('');
      }
    });

    if (this.platform.SAFARI && sessionStorage.getItem('SAFARI_NOTIFICATION_SEEN') === null) {
      snackBarRef = this.snackBar.open('Safari browsers are not fully supported', 'OK');
      this.unsubscribe.sink = snackBarRef.onAction().subscribe(() => sessionStorage.setItem('SAFARI_NOTIFICATION_SEEN', '1'));
    }
  }

  ngOnDestroy() {
    this.unsubscribe.unsubscribe();
  }

  logout() {
    this.left.close();
    this.router.navigateByUrl('/logout').catch(() => {
    });
  }

  canAccessDistributionAccounts(): boolean {
    return AuthorizationUtils.canAccessDistributionAccounts(this.user);
  }
}
